(function() {
  var __snippets__ = {};
  (function() {
    var element = document.getElementById("snippets-script");
    var attribute = element ? element.getAttribute("data-snippets") : '';
    var snippets = attribute.split(",").filter(Boolean);

    for (var i = 0; i < snippets.length; i++) {
      __snippets__[snippets[i]] = true;
    }
  })();
  (function() {
  if (!__snippets__["search-modal"] && !Shopify.designMode) return;
  try {
    if(document.querySelectorAll('.search-term').length > 0){
    document.querySelectorAll('.search-term').forEach(function(elem){
      elem.onclick = function(){
        let text = elem.innerText;
        document.querySelector('.search-input').value = text;
        document.querySelector('.search-input').dispatchEvent(new Event('input keydown', { bubbles: true }));
      }
    })
  }
  (function () {
  const STORAGE_KEY = 'search_recent';
  const MAX_ITEMS = 6;
  const MODAL = '#search-modal';

  const getRecent = () => {
    try { return JSON.parse(localStorage.getItem(STORAGE_KEY)) || []; }
    catch { return []; }
  };
  const saveRecent = (t) => {
    try { localStorage.setItem(STORAGE_KEY, JSON.stringify(t)); } catch {}
  };

  function addSearch(term) {
    term = (term || '').trim();
    if (term.length < 2) return;
    let terms = getRecent().filter(t => t.toLowerCase() !== term.toLowerCase());
    terms.unshift(term);
    saveRecent(terms.slice(0, MAX_ITEMS));
  }

  // force = true  -> always rebuild (used after a new search is saved)
  // force = false -> only fill if empty (used by the observer, prevents loops)
  function renderRecent(force) {
    const wrapper = document.getElementById('recent-searches-wrapper');
    const list = document.getElementById('recent-searches-list');
    if (!wrapper || !list) return;

    const terms = getRecent();
    if (!terms.length) {
      if (wrapper.style.display !== 'none') wrapper.style.display = 'none';
      return;
    }

    if (force || list.children.length === 0) {
      const root = (window.Shopify && Shopify.routes && Shopify.routes.root) || '/';
      list.innerHTML = terms.map(t =>
        `<li><a href="${root}search?q=${encodeURIComponent(t)}">${t}</a></li>`
      ).join('');
    }
    if (wrapper.style.display !== '') wrapper.style.display = '';
  }

  let saveTimeout;

  // Save while typing (debounced)
  document.addEventListener('input', (e) => {
    if (!e.target.matches(`${MODAL} .search-input, ${MODAL} input[name="q"]`)) return;
    const term = e.target.value.trim();
    clearTimeout(saveTimeout);
    if (term.length >= 2) {
      saveTimeout = setTimeout(() => { addSearch(term); renderRecent(true); }, 800);
    }
  });

  // Save on submit (Enter / "View all")
  document.addEventListener('submit', (e) => {
    if (!e.target.closest(`${MODAL} form`)) return;
    clearTimeout(saveTimeout);
    const input = e.target.querySelector('.search-input, input[name="q"]');
    if (input) { addSearch(input.value); renderRecent(true); }
  });

  // Save when clicking a predictive result (skip clicks on the recent list itself)
  document.addEventListener('click', (e) => {
    const link = e.target.closest(`${MODAL} .predictive-search a`);
    if (link && !link.closest('#recent-searches-wrapper')) {
      addSearch(link.textContent);
    }
  });

  // Horizon rebuilds the empty state each time results clear, which wipes our
  // injected <li>s. Watch the modal and re-render whenever it reappears.
  function watch() {
    const modal = document.querySelector(MODAL);
    if (!modal) return;
    new MutationObserver(() => renderRecent(false)).observe(modal, {
      attributes: true,
      attributeFilter: ['open', 'class'],
      childList: true,
      subtree: true,
    });
  }

  function boot() { renderRecent(false); watch(); }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', boot);
  } else {
    boot();
  }
})();

document.querySelector('.search_close').addEventListener('click', function (e) {
  e.preventDefault();

  const dialog = document.querySelector('.dialog-modal[open]');
  if (dialog) {
    dialog.close();
  }
});
  } catch(e) { console.error(e); }
})();

})();
